export default __webpack_public_path__ + "static/media/fuzzing-full-linux.499c1993.avif";